import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useHistory } from "react-router-dom";
import { Input } from "reactstrap";
import Api from "./api/api";
import MyLoader from "./util/loader";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import ListItemActionButton from "./common/ListItemActionButton";
import ListItemContainer from "./common/ListItemContainer";
import useReorder from "../hooks/use-reorder";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import PageActionButton from "./common/PageActionButton";

var tempVideoId = "";

const VideoCmp = ({ model }) => {
  const addMainShot = useRef(null);

  const [models, setModels] = useState([]);
  const [editVideoId, setEditVideoId] = useState("");
  const [editVideoTitle, setEditVideoTitle] = useState("");
  const [loader, setLoader] = useState(false);

  const { isReordering, toggleIsReordering, reorderedItems, onReorderEnd, saveOrdering } =
    useReorder({
      items: models,
      onSave: (data) =>
        Api.updateVideoOrder({
          params: { data },
          onSuccess: () => {
            showToast("success", "Ordering is updated!");
            loadData();
            setTimeout(() => toggleIsReordering(), 1000);
          },
          onError: () => {
            loadData();
            toggleIsReordering();
          },
        }),
    });

  useEffect(() => {
    loadData();
  }, [model]);

  const handleDownload = async (url) => {
    try {
      window.location.href = url;
      // const response = await fetch(url, {
      //     headers: {
      //         'Access-Control-Allow-Origin': 'http://localhost:3000',
      //         'Access-Control-Allow-Credentials': 'true',
      //     }
      // });
      // const playlist = await response.text();
      // const videoUrl = playlist.split('\n').filter((line) => !line.startsWith('#'))[0];
      // console.log('videoUrl: ' + videoUrl);
      // setDownloadUrl(videoUrl);
    } catch (error) {
      console.error(error);
    }
  };

  const loadData = () => {
    console.log("loadVideosOf: " + model.id);
    setLoader(true);
    Api.getCategoryVideos(
      model.id,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          setModels(response.data);
        }
      },
      (error) => {
        setLoader(false);
      }
    );
  };

  async function downloadVideo(video) {
    let url = video.file_name;
    // window.location.href = url

    try {
      const response = await fetch(url);
      const text = await response.text();
      const dUrl = window.URL.createObjectURL(new Blob([text]));
      console.log("dUrl: " + dUrl);
    } catch (error) {
      console.error(error);
    }
  }

  const deleteVideo = (video) => {
    if (window.confirm("Are you sure you wish to delete this video?")) {
      setLoader(true);
      Api.deleteCategoryVideo(
        model.id,
        video.id,
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Video deleted!");
            loadData();
          }
        },
        (error) => {
          setLoader(false);
          showToast("error", "Request failed!");
        }
      );
    }
  };

  const updateVideoTitle = (video, title) => {
    setLoader(true);
    Api.updateVideoTitle(
      video.id,
      title,
      (response) => {
        setLoader(false);
        if (response.status === "success") {
          showToast("success", "Video title updated!");
          const list = models.map((item) => {
            if (item.id === video.id) {
              return { ...item, title: title };
            } else {
              return item;
            }
          });
          setModels(list);
        }
      },
      (error) => {
        setLoader(false);
        showToast("error", "Request failed!");
      }
    );
  };

  const updateVideoThumb = (video_id, file) => {
    setLoader(true);
    Api.updateVideoThumb(
      video_id,
      file,
      (response) => {
        setLoader(false);
        loadData();
      },
      (error) => {
        setLoader(false);
        showToast("error", "Request failed!");
      }
    );
  };

  const renderVideoElement = (model, index) => {
    return (
      <VideoListItem
        model={model}
        index={index}
        addMainShot={addMainShot}
        editVideoId={editVideoId}
        editVideoTitle={editVideoTitle}
        setEditVideoTitle={setEditVideoTitle}
        updateVideoTitle={updateVideoTitle}
        handleDownload={handleDownload}
        deleteVideo={deleteVideo}
        setEditVideoId={setEditVideoId}
      />
    );
  };

  const SortableItem = SortableElement(({ value, ...rest }) => {
    return renderVideoElement(value, rest.index2);
  });

  const SortableList = SortableContainer(({ items }) => (
    <div>
      {items.map((value, index) => {
        return <SortableItem key={value.id} index={index} value={value} index2={index} />;
      })}
    </div>
  ));

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ marginTop: 10, display: "flex", justifyContent: "flex-start" }}>
        {models.length > 1 && (isReordering ? (
          <>
            <PageActionButton
              color={"blue"}
              onClick={() => {
                saveOrdering();
                // toggleIsReordering();
              }}
              text={"Save Order"}
            />

            <PageActionButton color={"red"} onClick={toggleIsReordering} text={"Cancel"} />
          </>
        ) : (
          <PageActionButton color={"blue"} onClick={toggleIsReordering} text={"Reorder"} />
        ))}
      </div>

      <input
        type="file"
        style={{ display: "none" }}
        ref={addMainShot}
        onChange={(event) => {
          // setMainShot(event.target.files[0]);
          // setMainShotUrl(URL.createObjectURL(event.target.files[0]))
          updateVideoThumb(tempVideoId, event.target.files[0]);
        }}
      />
      {isReordering && <SortableList items={reorderedItems} axis="xy" onSortEnd={onReorderEnd} />}

      {!isReordering &&
        models.map((model, index) => {
          return renderVideoElement(model, index);
        })}

      <MyLoader loader={loader} marginTop={0} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

const VideoListItem = ({
  index,
  model,
  addMainShot,
  editVideoId,
  editVideoTitle,
  setEditVideoTitle,
  setEditVideoId,
  updateVideoTitle,
  handleDownload,
  deleteVideo,
}) => {
  var history = useHistory();

  let className = index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";
  // <div className={className} style={{ marginTop: 0 }}>
  return (
    <ListItemContainer index={index} extraClassName="item-btn">
      <div style={{ marginTop: 0, display: "flex", width: "100%", userSelect: "none" }}>
        {/* <div className="item-btn" style={{ display: "flex", flexDirection: "column" }}> */}
        <div
          className="projects-item-photo"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={model.thumbnail}
            style={{
              padding: 1,
              width: 70,
              height: 70,
              objectFit: "cover",
            }}
            alt=""
          />
          <button
            onClick={() => {
              tempVideoId = model.id;
              addMainShot.current.click();
            }}
            style={{
              alignSelf: "flex-start",
              padding: 0,
              fontSize: 16,
              color: "blue",
              backgroundColor: "transparent",
              border: "0px",
            }}
          >
            Change
          </button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div className="projects-item-cat" style={{ flexGrow: 0 }}>
            <div style={{ fontSize: 14 }}>ID: {model.id}</div>
          </div>
          <div className="projects-item-cat" style={{ flexGrow: 0 }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {editVideoId === model.id ? (
                <Input
                  type="text"
                  placeholder="Edit Title"
                  style={{ minWidth: 400, fontSize: 14 }}
                  value={editVideoTitle}
                  onChange={(event) => {
                    setEditVideoTitle(event.target.value);
                  }}
                />
              ) : (
                <div style={{ fontSize: 16 }}>{model.title}</div>
              )}
              {editVideoId === model.id ? (
                <button
                  onClick={() => {
                    console.log("update title");
                    let newTitle = editVideoTitle;
                    updateVideoTitle(model, newTitle);
                    setEditVideoTitle("");
                    setEditVideoId("");
                  }}
                  style={{
                    alignSelf: "flex-start",
                    fontSize: 16,
                    color: "blue",
                    backgroundColor: "transparent",
                    border: "0px",
                  }}
                >
                  Save
                </button>
              ) : (
                <button
                  onClick={() => {
                    setEditVideoTitle(model.title);
                    setEditVideoId(model.id);
                  }}
                  style={{
                    alignSelf: "flex-start",
                    padding: 0,
                    fontSize: 16,
                    color: "blue",
                    backgroundColor: "transparent",
                    border: "0px",
                  }}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="projects-item-cat" style={{ display: "flex", justifyContent: "flex-end" }}>
          <ListItemActionButton
            color="blue"
            onClick={() => handleDownload(model.file_name.replace("/index.m3u8", ".mp4"))}
          >
            Download
          </ListItemActionButton>

          <ListItemActionButton
            color="gray"
            onClick={() =>
              history.push({
                pathname: "/play-video",
                state: { model: model },
              })
            }
          >
            View
          </ListItemActionButton>

          <ListItemActionButton color="red" onClick={() => deleteVideo(model)}>
            Delete
          </ListItemActionButton>
        </div>
        {/* </div> */}
      </div>
    </ListItemContainer>
  );
};

export default VideoCmp;
